let auth = null;
let callbackResolve = null;
let callbackReject = null;

const initCodeClient = (payload) => {
  try {
    auth = google.accounts.oauth2.initCodeClient({
      client_id: payload.client_id,
      scope: payload.scope,
      callback: (res) => {
        try {
          callbackResolve(res.code);
        } catch(err) {
          console.error(err);
          callbackReject(err);
        }
      },
      error_callback: (err) => {
        if (err.type == 'popup_failed_to_open') {
          console.warn("The popup window is failed to open");
        } else if (err.type == 'popup_closed') {
          console.warn("The popup window is closed before an OAuth response is returned");
        } else {
          console.warn(err);
        }
      }
    });
  } catch(err) { console.error(err); }
}

const requestCode = async () => {
  return new Promise((resolve, reject) => {
    callbackResolve = resolve;
    callbackReject = reject;
    auth.requestCode();
  });
}

export default {
  initCodeClient: initCodeClient,
  requestCode: requestCode
}